import React from "react";
import { ErrorMessage, Input, Wrapper } from "./styled";
import Typography from "../Typography";
import { Error as ErrorIcon } from "./assets/Error";

const TextInput = ({
  value,
  onChange,
  autoComplete,
  error,
  type = "text",
  placeholder,
  color = "#fff",
}) => {
  return (
    <Wrapper>
      <Input
        autoComplete={autoComplete}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        type={type}
        $color={color}
        $error={error}
      />
      {error && (
        <ErrorMessage>
          <ErrorIcon width={12} height={12} />
          <Typography color="primary" variant="small">
            {error}
          </Typography>
        </ErrorMessage>
      )}
    </Wrapper>
  );
};

export default TextInput;
